import axios from 'axios';

const msUrl = process.env.VUE_APP_URL_API_MS;

export default {
    buhReports: async function (data) {
        data.UserID = localStorage.getItem('UserID');
        data.SessionKey = localStorage.getItem('SessionKey');

        const response = await axios.post(msUrl + '/buh-reports.php', data, {responseType: 'blob'});
        if (response.data.type === 'application/json') {
            const text = await response.data.text();
            throw JSON.parse(text);
        } else {
            return response; // Возвращаем файл (Blob)
        }
    },
    callBuhApi: async function (data) {
        data.UserID = localStorage.getItem('UserID');
        data.SessionKey = localStorage.getItem('SessionKey');
        const response = await axios.post(msUrl + '/callBuhApi.php', data);
        if (response.data.Error.Code > 0) {
            throw response.data.Error;
        } else {
            return response.data.Data;
        }
    },
}